/*
 * ****************************************************************************
 * Copyright (C) 2018-2018, All rights reserved.
 * Project: chessmate
 * Created On: March 23rd, 2018
 * Last Modified: March 23rd, 2018
 * ****************************************************************************
 */

import * as React from 'react';
import * as Mui from 'mui';
import * as history from 'history';
import { PopupMenu } from 'components/popupMenu';
import { AppEventsContext } from 'contexts/appEventsContext';
import constants from 'app/constants';

/** ToolbarProps - Properties */
export interface ToolbarProps extends React.HTMLProps<HTMLElement> {
  toggleNav?: () => void;
  buttonType: 'new' | 'play';
  history: history.History;
}

/** Toolbar */
export class Toolbar extends React.Component<ToolbarProps> {

  constructor(props: ToolbarProps, ctx: any) {
    super(props, ctx);
  }

  toggleNav(event: any) {
    if (this.props.toggleNav) {
      this.props.toggleNav();
    }
  }

  navigate(link: string) {
    this.props.history.push(link);
  }

  render() {
    return (
      <AppEventsContext>{events => (
        <Mui.AppBar id="toolbar" position="static" className={this.props.className}>
          <Mui.Toolbar disableGutters variant="dense">
            {/* {!!this.props.toggleNav && (
            <Mui.IconButton color="inherit" aria-label="Menu" className="tb-menu-toggle" onClick={e => this.toggleNav(e)}>
              <Mui.Icon>menu</Mui.Icon>
            </Mui.IconButton>
          )} */}
            <div className="tb-menu-gap"></div>
            <PopupMenu icon="menu" items={() => events.buildMenu()} color="inherit" />
            <div className="tb-menu-gap"></div>
            <div className="app-title">
              <Mui.Typography align="center" color="textSecondary" variant="title">
                <div className="mr-8 fas fa-chess" />
                {constants.title}
              </Mui.Typography>
            </div>
            <div className="tb-menu-gap"></div>
            <div className="fill right">
              {(this.props.buttonType === 'new') && (
                <Mui.Button
                  color="secondary"
                  aria-label="Setup Board"
                  title="Setup Board"
                  onClick={events.menuClick('new-game')}
                ><Mui.Icon>edit</Mui.Icon>Setup</Mui.Button>
              )}
              {(this.props.buttonType === 'play') && (
                <Mui.Button
                  color="secondary"
                  aria-label="Play"
                  title="Play"
                  onClick={events.menuClick('play-game')}
                ><Mui.Icon>play_arrow</Mui.Icon>Play</Mui.Button>
              )}
            </div>
            <div className="tb-menu-gap"></div>
          </Mui.Toolbar>
        </Mui.AppBar>
      )}</AppEventsContext>
    );
  }
}

export default Toolbar;


// WEBPACK FOOTER //
// ./src/views/home/components/toolbar.tsx